import { login, logout, getInfo, weichatLogin } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    weichatLoginStatus: '',
    roles: [],
    friendlyName: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_WEICHAT_LOGIN: (stata, status) => {
    state.weichatLoginStatus = status
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_FRIENDLY_NAME: (state, friendly_name) => {
    state.friendlyName = friendly_name
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, validateToken } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, validateToken: validateToken }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const data = response.data.user_info

        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { user_name, avatar, roles, friendly_name } = data
        commit('SET_NAME', user_name)
        commit('SET_AVATAR', avatar)
        commit('SET_ROLES', roles)
        commit('SET_FRIENDLY_NAME', friendly_name)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },

  // qrcode login
  qrcodeLogin({ commit }, qrcodeInfo) {
    const { code } = qrcodeInfo
    return new Promise((resolve, reject) => {
      weichatLogin({ code: code }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        commit('SET_WEICHAT_LOGIN', 1)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

